//  ################ core ##############################################

//  libraries
window.Swiper = require('swiper');
// require('bootstrap/js/dist/tooltip');
window.Cookies = require('js-cookie');
require('lazyloadxt/dist/jquery.lazyloadxt');
require('lazyloadxt/dist/jquery.lazyloadxt.srcset');
require('@fancyapps/fancybox/dist/jquery.fancybox');

// Uniqgmbh Libs
require('@uniq-legacy/lazy-load-xt-bg/js/jquery.lazyloadxt.bg');
require('@uniq-legacy/sticky-sidebar/js/uniqBase_stickySidebar');
require('@uniq-legacy/copy-to-clipboard/js/uniqBase_copyToClipboard');
require('@uniq-legacy/jquery-smooth-scrolling/js/jquery.smooth-scrolling');
require('@uniq-legacy/swiper-onesidepadding/js/swiper.onesidepadding');

// Bootstrap Libs
require('../node_modules/bootstrap/js/dist/util');
require('../node_modules/bootstrap/js/dist/tab');
require('../node_modules/bootstrap/js/dist/alert');

// Library addons
require('./helper/swiper/plugins/swiper-retina');
// require('./helper/polyfill/pictureSupport');
require('./uniq-base/module/uniqBase_fancyBoxWrapper');

// //################ app ###############################################
require('./frontend/header');
require('./frontend/table');
require('./frontend/to-top');
require('./frontend/collapse');
require('./frontend/readmore');
require('./frontend/single');
require('./frontend/three-panel-collage');
require('./frontend/swiper/swiper');
require('./frontend/swiper/scroll-container-swiper');
require('./frontend/swiper/detailbox-swiper');
require('./frontend/breedfilter');
